const timedate = require('../../js-handler/time-date')
const timetime = require('../../js-handler/time-time')
const actions  = require('./chat-actions')
const { escapeUserChatHtml, formatIaAnswerHtml } = require('./chat-ia-format')

export function renderUserList(users) {
    const chatLeftContainer = document.querySelector('.chat-left')
    let html = ''

    users.forEach(user => {
        const detailObj = `{"click": [{"dest":"chat", "act":"selectUser", "userId": ${user.id}, "name": "${user.name}"}]}`

        html += `
        <div class="chat-cont" data-id="${user.id}" data-detail='${detailObj}'>
            <div class="chat-cont-face" style="background-image: url('${user.avatar}')"></div>
            <label>${user.name}</label>
            ${user.status ? '<span class="chat-cont-active"></span>' : ''}
        </div>`
    })

    chatLeftContainer.innerHTML = html
}

function generateMessageHTML(msg, isMine) {
    const sideClass = isMine ? 'chat-section-2' : 'chat-section-1'
    const time = timetime.formatAMPM(msg.time)
    const date = timedate.getdateshort(msg.time)

    let statusClass = '';
    let svgIcon = 'check';

    if (isMine) {
        if (msg.status === 'sent') {
            statusClass = 'msg-sent';
            svgIcon = 'eye';
        } else if (msg.status === 'read') {
            statusClass = 'msg-read';
            svgIcon = 'eye';
        }
    }

    const bodyHtml = isMine ? escapeUserChatHtml(msg.sms) : formatIaAnswerHtml(msg.sms)

    return `
    <div class="chat-section ${sideClass} pb12 ${statusClass}" data-msg-id="${msg.id || ''}">
        <div class="chat-section-avatar" style="background-image: url('${msg.avatar}')"></div>
        <label class="chat-section-comment">
            <div class="chat-section-text ${isMine ? '' : 'chat-section-text--ia'}">${bodyHtml}</div>
            <span class="chat-section-time">${time}</span>
            <svg><use xlink:href="css/svg.svg#chat-arrow"></use></svg>
        </label>
    </div>`
}

export function renderHistory(history) {
    const chatTextContainer = actions.getActiveChatContainer();
    if (!chatTextContainer) {
        console.warn("No se encontró un contenedor de chat activo y visible.");
        return;
    }
    
    let html = '';
    let rows = [];

    if (history && typeof history === 'object' && !Array.isArray(history)) {
        rows = [history];
    } else if (Array.isArray(history)) {
        if (history[0]?.data) {
            rows = history[0].data;
        } else if (Array.isArray(history[0])) {
            rows = history[0];
        } else {
            rows = history;
        }
    }

    if (!Array.isArray(rows) || !chatTextContainer) return;

    rows.forEach(row => {
        if (row.question && row.question !== "") {
            html += generateMessageHTML({
                id: row.id + '_q',
                sms: row.question,
                status: row.status,
                time: row.dateTime || new Date().toISOString(),
                avatar: row.avatar || 'css/img/pic/person.svg'
            }, true);
        }

        if (row.answare && row.answare !== "") {
            html += generateMessageHTML({
                id: row.id + '_a',
                sms: row.answare,
                status: 'read',
                time: row.dateTime || new Date().toISOString(),
                avatar: 'css/img/pic/ia.png'
            }, false);
        }
    });

    chatTextContainer.innerHTML = html;
}

export function appendMessage(msg, isMine) {
    const chatTextContainer = actions.getActiveChatContainer();
    if (chatTextContainer) {
        chatTextContainer.insertAdjacentHTML('beforeend', generateMessageHTML(msg, isMine));
    }
}